import * as React from "react";
import { Classes, Icon } from "@blueprintjs/core";
const _CurrencyInput = require("react-currency-input").default;

interface ICurrencyInputProps {
  value: number;
  onChange: (value: number) => void;
  allowNegative?: boolean;
  valid?: boolean;
  precision?: number;
  showIcon?: boolean;
}

export default class CurrencyInput
  extends React.Component<ICurrencyInputProps, {}>
{
  handleChange = (_evt: Event, _maskValue: string, value: number) => {
    this.props.onChange(value);
  };

  render() {
    let { onChange, showIcon, ...props } = this.props;
    let showIcon_ = showIcon === undefined ? true : false;

    return (
      <div className={Classes.INPUT_GROUP} style={{width: "100%"}}>
        <_CurrencyInput
          className={Classes.INPUT}
          decimalSeparator=","
          thousandSeparator="."
          {...props}
          onChangeEvent={this.handleChange}
        />
        {showIcon_ &&
          (
            <Icon
              icon={this.props.valid ? "tick" : "cross"}
              intent={this.props.valid ? "success" : "danger"}
            />
          )}
      </div>
    );
  }
}
